import { createClient as createSupabaseClient, type SupabaseClient } from '@supabase/supabase-js';

let browserClient: SupabaseClient | null = null;

/**
 * Returns the browser Supabase client, or null when the public Supabase
 * environment variables are not configured. Callers must handle the null
 * case — auth and database features are simply unavailable without it.
 */
export function createClient(): SupabaseClient | null {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const anonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  if (!url || !anonKey) {
    // eslint-disable-next-line no-console
    console.warn(
      'Supabase is not configured: set NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY.'
    );
    return null;
  }

  if (!browserClient) {
    browserClient = createSupabaseClient(url, anonKey);
  }

  return browserClient;
}
